import { getEmissionsByUserRepository } from "../Infrastructure/Emissions.repository";

export async function getEmissionsByUserLogic(years = []) {
  return getEmissionsByUserRepository(years);
}